import { render, staticRenderFns } from "./PostSheare.component.vue?vue&type=template&id=bf63bf20&"
import script from "./PostSheare.component.vue?vue&type=script&lang=js&"
export * from "./PostSheare.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports